/* eslint-disable camelcase */
import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { useLazyAuthInitTokenQuery } from 'modules/login/api'
import { setAuthInfo } from 'modules/login/helpers/token/token'

import { orderGuestRedirectCreateRoute } from '../routes/OrderGuestRedirectCreateRoute'
import { orderRedirectRoute } from '../routes/OrderRedirectRoute'

export const OrderRedirect = () => {
  const navigate = useNavigate()
  const { auth_code, state } = orderRedirectRoute.useSearch()
  const [authInitToken] = useLazyAuthInitTokenQuery()

  useEffect(() => {
    if (auth_code && state) {
      authInitToken({ code: auth_code, state }).then(({ data }) => {
        if (data) {
          setAuthInfo(data)
          localStorage.isLogged = true
          navigate(orderGuestRedirectCreateRoute)
        } else {
          navigate({ to: '/', replace: true })
        }
      })
    }
  }, [authInitToken, auth_code, navigate, state])

  return null
}
